import { useMutation } from '@tanstack/react-query';

import createPlaidLinkToken from './usePlaidLinkToken.request';

const usePlaidLinkToken = () => {
    return useMutation({
        mutationFn: createPlaidLinkToken,
    });
};

export default usePlaidLinkToken;
